import { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
const useSafeStore = ()=>{
    const reduxContext = useContext(ReactReduxContext);
    if (reduxContext) {
        return reduxContext.store;
    }
    return null;
};
export default {
    'react-redux': {
        useSafeStore
    }
};
